export default "__VITE_ASSET__4907lhpl__"